import { NavLink } from 'react-router-dom';
import { Container, Navbar, Nav, NavDropdown } from 'react-bootstrap';
import styled from "styled-components";

import NavLogo from '../../assets/images/Secondary Logo - Horizontal - Color.png';
import MobileNavLogo from '../../assets/images/Secondary Logo - Vertical - Color.png';
import '../GlobalStyle.css';
import { BPSPrimaryButton } from '../styled/Buttons';

const NavItemLabel = styled.div`
    border-bottom: 1px solid transparent;

    &:hover {
        border-bottom: 1px solid #1c304c;
    }
`
const MobileCTA = styled.div`
    border-top: 1px solid #ccc;
    width: 100%;
    margin: auto;
    text-align: center;
    padding-top: 1rem;
`

const Navigation = () => {
    return (
        <>
            <Navbar collapseOnSelect expand="lg" className='shadow-sm bg-white justify-content-between' sticky='top'>
                <Container fluid>
                    <Navbar.Brand href="/" className='d-inline'>
                        <img src={NavLogo} alt="Best Payment Solutions" width='300px' className='d-none d-md-inline' />
                        <img src={MobileNavLogo} alt="Best Payment Solutions" width='160px' className='d-inline d-md-none' />
                    </Navbar.Brand>
                    <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                    <Navbar.Collapse id="responsive-navbar-nav">
                        <Nav className="me-auto">
                            <NavItemLabel>
                                <NavDropdown title="Programs">
                                    <NavDropdown.Item href="/channel-sales">
                                        Channel Sales
                                    </NavDropdown.Item>
                                    <NavDropdown.Item href="/sales-contests">
                                        Sales Contests
                                    </NavDropdown.Item>
                                    <NavDropdown.Item href="/referrals">
                                        Referrals
                                    </NavDropdown.Item>
                                    <NavDropdown.Item href="/rebates">
                                        Rebates
                                    </NavDropdown.Item>
                                    <NavDropdown.Item href="/payments">
                                        Payments
                                    </NavDropdown.Item>
                                    <NavDropdown.Item href="/ebike-incentives">
                                        Ebike Incentives
                                    </NavDropdown.Item>
                                    <NavDropdown.Item href="/custom-incentive-programs">
                                        Custom Incentive Programs
                                    </NavDropdown.Item>
                                </NavDropdown>
                            </NavItemLabel>
                            <NavItemLabel>
                                <NavDropdown title="Products & Services">
                                    <NavDropdown.Item href="/technology">
                                        Technology
                                    </NavDropdown.Item>
                                    <NavDropdown.Item href="/support-services">
                                        Support Services
                                    </NavDropdown.Item>
                                    <NavDropdown.Item href="/visa-prepaid-cards">
                                        Visa Prepaid Cards
                                    </NavDropdown.Item>
                                    <NavDropdown.Item href="/egift-cards">
                                        EGift Cards
                                    </NavDropdown.Item>
                                    {/* <NavDropdown.Item href="/card-ordering">
                                        Card Ordering
                                    </NavDropdown.Item> */}
                                </NavDropdown>
                            </NavItemLabel>
                            <NavItemLabel>
                                <NavDropdown title="Resources">
                                    <NavDropdown.Item href="/about">
                                        About
                                    </NavDropdown.Item>
                                    <NavDropdown.Item href="/knowledge-center">
                                        Knowledge Center
                                    </NavDropdown.Item>
                                    <NavDropdown.Item href="/faqs">
                                        FAQs
                                    </NavDropdown.Item>
                                </NavDropdown>
                            </NavItemLabel>
                        </Nav>
                        <BPSPrimaryButton className='fs-6 d-none d-lg-inline' href='/schedule-demo'>Schedule A Demo</BPSPrimaryButton>
                    </Navbar.Collapse>
                    <MobileCTA className='my-2 d-lg-none'>
                        <BPSPrimaryButton className='fs-6' href='/schedule-demo'>Schedule A Demo</BPSPrimaryButton>
                    </MobileCTA>
                </Container>
            </Navbar>
        </>
    );
}

export default Navigation;